<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homes' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Stay' }" replace>待做作业</el-breadcrumb-item>
				<el-breadcrumb-item>答题</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div id="time" class="time_box p_m_t_30 p_flex p_f_b p_f_a">
			<div class="p_flex type_size_20 p_f_a">
				<span class="el-icon-time"></span>
				<span class="type_size_18 p_m_l_20">{{chronoscope}}</span>
			</div>
			  <el-button type="success" @click='onSubmit()'>提交</el-button>
		</div>
		<div class="mine_list overflow  small_hand" :style="{ height: height + 'px' }">
			<answer-deatils ref="answerDeatils" :shows='shows' :data="data" :jobPublisId="jobPublishId"></answer-deatils>
		</div>
		<pop-up :show='show'  @closes='show = false' @goButton='show = false'></pop-up>
	</div>
</template>

<script>
import AnswerDeatils from './commponents/deatils.vue';
import PopUp from './commponents/popUp.vue'
export default {
	name: 'StayAnswer',
	components: {
		AnswerDeatils,
		PopUp,
	},
	data() {
		return {
			chronoscope: '00:00',
			height: 0,
			show:false,
			jobPublishId: null,
			data: [],
			shows:false
		};
	},


	mounted() {
		var jobPublishId = parseInt(this.$route.query.jobPublishId)
		if( jobPublishId ){
			this.jobPublishId = jobPublishId
			this.indexInfo();
			this.getQuestionList(jobPublishId)
		}else{
			this.$router.back()
		}
	},

	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/StayAnswer') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	},
	methods: {

		onSubmit(){
			this.$refs.answerDeatils.onSubmit()
		},

		getQuestionList(jobPublishId){
			this.$request.ajax(this).post('api_student/start_answer',{job_publish_id: jobPublishId}).then(res=>{
				this.hms(res.data.service_time, res.data.start_time)
				if (res.data.service_time > res.data.submit_time) {
					this.shows = true;
				} else {
					this.shows = false;
				}
				this.$request.ajax(this).post('api_student/exercise_question_list',{job_publish_id: jobPublishId}).then(res=>{
					this.data = res.data
				})
			}).catch(res=>{
				this.$router.back()
			})

		},

		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var time = document.getElementById('time').offsetHeight;
			var height = box - head - time - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},

		hms(thisTime,startTime) {
			var _this = this
			let result = parseInt(thisTime-startTime)
			let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
			let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
			let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

			let res = '';
			if(h !== '00') res += `${h}:`;
			if(m !== '00') res += `${m}:`;
			res += `${s}`;
			_this.chronoscope = res
			setTimeout(function(){
				_this.hms(thisTime+1,startTime)
			}, 1000)
		}
	}
};


</script>
<style lang="scss" scoped>
.mine_header {
	background-color: #fafafa;
	height: 60px;
}

.header_left > div {
	height: 100%;
	position: relative;
	margin-left: 260px;
}

.header_left > div:nth-child(2) {
	margin-left: 50px;
}

.header_left {
	height: 100%;
}

.header_heng {
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
	width: 80%;
	height: 2px;
	background-color: #000000;
}
.tababr_com {
	font-weight: bold;
}
.heaer_btn {
	margin-left: 440px;
}
.mine_list {
	padding: 0 60px;
	background-color: #ffffff;
}
.time_box {
	background: #fafafa;
	padding: 15px 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/stay/answer.vue